import React from "react";
import { Table, Divider, Popconfirm, Space } from "antd";
import { useTranslation } from "react-i18next";

import ApiConstants from "../../../api/ApiConstants";

import Edit from "../../../public/images/dashboard/tables/edit.svg";
import Delete from "../../../public/images/dashboard/tables/delete.svg";

import "../../../public/sass/layout/_index.scss";

const SupportTable = ({
  loading,
  getSupportById,
  deleteSupport,
  web_pages,
}) => {
  const [t, i18n] = useTranslation();
  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: 50,
      render: (text, record, index) => {
        return (
          <>
            {index+1}
          </>
        )
      }
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Website",
      dataIndex: "link",
      key: "Website",
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 100,
      render: (e) => (
        <Space size="middle">
          <a onClick={() => getSupportById(e?.id)}>
            <img src={Edit} alt="Edit" />
          </a>
          <Popconfirm
            title={t("are_you_sure")}
            onConfirm={() => deleteSupport(e?.id)}
          >
            <a>
              <img src={Delete} alt="Delete" />
            </a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Divider />
      <Table
        loading={loading}
        columns={columns}
        className="table"
        dataSource={web_pages}
        scroll={{ y: ApiConstants.TABLE_HEIGHT }}
      />
    </div>
  );
};
export default SupportTable;
